module.exports = __webpack_public_path__ + "img/wrapper__stepper__inactive.e4e765db.svg";